export function getIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0)
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

    // If IE 11 then look for Updated user agent string.
    else if (!!navigator.userAgent.match(/Trident\/7\./))
        return 11;

    else
        return 0; //It is not IE
}

/**
* Duck typing to determine the browser.
* Reading from the user agent string is not reliable but we must do it for Safari.
* */

declare const InstallTrigger: any;
export function isFirefox() {
    return typeof InstallTrigger !== 'undefined';
}

export function isSafari() {
    return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
}

export function isIE() {
    return /*@cc_on!@*/false || !!(document as any).documentMode;
}

export function isEdge() {
    return !isIE() && !!(window as any).StyleMedia;
}

export function isChrome() {
    return !!(window as any).chrome && (!!(window as any).chrome.webstore || !!(window as any).chrome.runtime);
}
